export default {
  topic: 'Mineur',
  titles: {
    currentSituation: 'Situation actuelle',
    nonCustomerQualification: 'Votre qualification client',
    updateQualification: 'Mise à jour de vos qualifications',
    synthesis: 'Synthèse des orientations retenues',
    contractSelection: "Montant à allouer à votre projet d'investissement",
    investmentConfiguration: 'Paramétrer votre opération',
    qualificationCustomer: 'Votre profil investisseur',
    qualificationMinor: 'Votre profil investisseur',
    financialInvestmentSummary: 'Récapitulatif investissements financiers',
    financialInvestmentAllocation: 'Investissements financiers',
    pivotAccountFunding: "Prélèvement de l'apport",
    report: "Rapport d'adéquation",
  },
}
